import { Icons } from '@app/models/Icon/Icon.model';

export interface IconsState {
  icons: Icons;
}

export const FETCH_ICONS_REQUEST = 'FETCH_ICONS_REQUEST';
export const FETCH_ICONS_SUCCESS = 'FETCH_ICONS_SUCCESS';

export interface FetchIconsAction {
  type: typeof FETCH_ICONS_REQUEST;
}

export interface FetchIconsSuccessAction {
  type: typeof FETCH_ICONS_SUCCESS;
  icons: Icons;
}

export type IconsActionTypes = FetchIconsAction | FetchIconsSuccessAction;
